import { createAction } from '@reduxjs/toolkit';

import { apologise } from './apology.thunks';
import { getApiConf } from './subscriptions.thunks';
import { layoutChanged } from './global.thunks';

import { UtilsAPI } from '../../api/utils.api';

import type { Json } from '../../types/json';
import type { SomeObject } from '../../types/common.types';
import type { AppThunk, ConfigPanelType } from '../../types/state.types';
import type { PipeConfig } from '../../types/pipes.types';

export const panelToggled = createAction<ConfigPanelType>('editor/panelToggled');
export const panelShown = createAction<ConfigPanelType>('editor/panelShown');
export const panelHidden = createAction<ConfigPanelType>('editor/panelHidden');
export const dirtyStateUpdated = createAction<{
  isDirty: boolean;
  unsavedEditedConfig?: PipeConfig;
}>('editor/dirtyStateUpdated');
export const reformatConfigLoaded = createAction<any>('editor/reformatConfigLoaded');
export const EditorActions = {
  togglePanel(panel: ConfigPanelType): AppThunk {
    return (dispatch) => {
      dispatch(panelToggled(panel));
      dispatch(layoutChanged());
    };
  },

  showPanel(panel: ConfigPanelType): AppThunk {
    return (dispatch) => {
      dispatch(panelShown(panel));
      dispatch(layoutChanged());
    };
  },

  hidePanel(panel: ConfigPanelType): AppThunk {
    return (dispatch) => {
      dispatch(panelHidden(panel));
      dispatch(layoutChanged());
    };
  },

  getReformatConfig(): AppThunk {
    return function (dispatch, getState) {
      return UtilsAPI.getReformatConfig(getApiConf(getState))
        .then((config) => dispatch(reformatConfigLoaded(config)))
        .catch((error) => dispatch(apologise(error)));
    };
  },

  // TODO: IS-6787 This is not really a Redux action; it's dispatched as one so it can
  // access `getState()`. Should rethink this.
  // Edit: this is now just an API call with the apologise error handler
  // need to solve error handling better, and then this doesn't have to be here
  reformatCode(code: string, styleOptions: SomeObject): AppThunk {
    return function (dispatch, getState) {
      return UtilsAPI.reformatCode(getApiConf(getState), code, styleOptions).catch((error) =>
        dispatch(apologise(error))
      );
    };
  },

  // TODO: IS-6787 This is not really a Redux action; it's dispatched as one so it can
  // access `getState()`. Should rethink this.
  // Edit: this is now just an API call with the apologise error handler
  // need to solve error handling better, and then this doesn't have to be here
  validateConfig(config: Json): AppThunk {
    return function (dispatch, getState) {
      return UtilsAPI.validateConfig(getApiConf(getState), config).catch((error) =>
        dispatch(apologise(error))
      );
    };
  },

  dirtyStateUpdated,
};
